/* GEMA v3 — Premium Motion
   Todas las animaciones "de lujo": preloader, hero letra por letra, parallax, cinta,
   cursor, botón magnético, transiciones de página. Depende de GSAP + ScrollTrigger + Lenis
   (CDN). Si no cargan, el <head> quita `js-motion` y la tienda se ve normal sin animar.
   Regla: nada de aquí es necesario para comprar. Solo embellece. */
(function () {
  var html = document.documentElement;
  if (!window.gsap || !window.ScrollTrigger) { html.classList.remove('js-motion', 'is-loading'); return; }
  window.__gemaMotion = true;
  if (!html.classList.contains('js-motion')) return; // "reducir movimiento": todo visible, sin animar

  gsap.registerPlugin(ScrollTrigger);
  // En móvil la barra del navegador cambia la altura al hacer scroll: no recalcular por eso (evita brincos)
  ScrollTrigger.config({ ignoreMobileResize: true });
  // BUG REAL (visto en producción): con Lenis, el PRIMER refresh tras un cambio de scroll mide las
  // posiciones con la posición de scroll anterior (cache viejo) y todo queda desfasado; el segundo
  // refresh consecutivo sí mide bien. Por eso cada refresh (manual o por resize) se repite una vez.
  var reRefresh = false;
  ScrollTrigger.addEventListener('refresh', function () {
    if (reRefresh) { reRefresh = false; return; }
    reRefresh = true;
    ScrollTrigger.refresh();
  });
  var EASE = 'cubic-bezier(.22,.61,.36,1)';
  var OUT = 'power3.out';
  var esMouse = html.classList.contains('has-pointer');
  var movil = window.matchMedia('(max-width: 920px)').matches;

  // ── Scroll suave (Lenis) ──
  var lenis = null;
  if (window.Lenis) {
    lenis = new Lenis({ lerp: 0.09, smoothWheel: true, syncTouch: false });
    window.__lenis = lenis;
    lenis.on('scroll', ScrollTrigger.update);
    gsap.ticker.add(function (t) { lenis.raf(t * 1000); });
    gsap.ticker.lagSmoothing(0);
    // Las filas de productos manejan su propia rueda (horizontal); Lenis no se mete ahí
    document.querySelectorAll('.row').forEach(function (r) { r.setAttribute('data-lenis-prevent-wheel', ''); });
    document.querySelectorAll('.mnav, .cd-body').forEach(function (r) { r.setAttribute('data-lenis-prevent', ''); });
    // Anclas internas con scroll suave
    document.addEventListener('click', function (e) {
      var a = e.target.closest('a[href^="#"]');
      if (!a || a.getAttribute('href').length < 2) return;
      var dest = document.querySelector(a.getAttribute('href'));
      if (!dest) return;
      e.preventDefault();
      lenis.scrollTo(dest, { offset: -60, duration: 1.4 });
    });
  }

  // ── Partir texto en letras / palabras (conservando spans internos como .g) ──
  function partir(el, modo) {
    var frag = document.createDocumentFragment();
    function procesar(nodo, destino) {
      Array.prototype.slice.call(nodo.childNodes).forEach(function (n) {
        if (n.nodeType === 3) {
          n.textContent.split(/(\s+)/).forEach(function (pal) {
            if (!pal) return;
            if (/^\s+$/.test(pal)) { destino.appendChild(document.createTextNode(' ')); return; }
            var w = document.createElement('span'); w.className = 'w';
            if (modo === 'chars') {
              pal.split('').forEach(function (c) { var ch = document.createElement('span'); ch.className = 'ch'; ch.textContent = c; w.appendChild(ch); });
            } else {
              var ch = document.createElement('span'); ch.className = 'ch'; ch.textContent = pal; w.appendChild(ch);
            }
            destino.appendChild(w);
          });
        } else if (n.nodeType === 1) {
          var clon = n.cloneNode(false);
          procesar(n, clon);
          destino.appendChild(clon);
        }
      });
    }
    procesar(el, frag);
    el.innerHTML = '';
    el.appendChild(frag);
    return el.querySelectorAll('.ch');
  }
  document.querySelectorAll('[data-split="chars"]').forEach(function (el) { partir(el, 'chars'); });
  document.querySelectorAll('[data-split="words"]').forEach(function (el) { partir(el, 'words'); });

  // ── Cursor propio ──
  if (esMouse) {
    var cur = document.querySelector('.cursor');
    if (cur) {
      var dot = cur.querySelector('.cur-dot'), ring = cur.querySelector('.cur-ring'), txt = cur.querySelector('.cur-txt');
      var dx = gsap.quickTo(dot, 'x', { duration: 0.08, ease: 'none' }), dy = gsap.quickTo(dot, 'y', { duration: 0.08, ease: 'none' });
      var rx = gsap.quickTo(ring, 'x', { duration: 0.42, ease: OUT }), ry = gsap.quickTo(ring, 'y', { duration: 0.42, ease: OUT });
      cur.classList.add('is-hidden');
      window.addEventListener('mousemove', function (e) {
        dx(e.clientX); dy(e.clientY); rx(e.clientX); ry(e.clientY);
        cur.classList.remove('is-hidden');
        var t = e.target.closest('[data-cur], a, button, [role="button"], label, input, select, textarea');
        cur.classList.toggle('is-txt', !!(t && t.hasAttribute('data-cur')));
        cur.classList.toggle('is-link', !!t && !t.hasAttribute('data-cur'));
        if (t && t.hasAttribute('data-cur')) txt.textContent = t.getAttribute('data-cur');
      }, { passive: true });
      document.addEventListener('mouseleave', function () { cur.classList.add('is-hidden'); });
      document.addEventListener('mouseenter', function () { cur.classList.remove('is-hidden'); });
    }
  }

  // ── Botón magnético ──
  if (esMouse) {
    document.querySelectorAll('[data-mag]').forEach(function (b) {
      var bx = gsap.quickTo(b, 'x', { duration: 0.5, ease: OUT }), by = gsap.quickTo(b, 'y', { duration: 0.5, ease: OUT });
      b.addEventListener('mousemove', function (e) {
        var r = b.getBoundingClientRect();
        bx((e.clientX - (r.left + r.width / 2)) * 0.28);
        by((e.clientY - (r.top + r.height / 2)) * 0.34);
      });
      b.addEventListener('mouseleave', function () { gsap.to(b, { x: 0, y: 0, duration: 0.9, ease: 'elastic.out(1,.45)' }); });
    });
  }

  // ── Hero: intro ──
  var hero = document.querySelector('[data-hero]');
  var intro = gsap.timeline({ paused: true, defaults: { ease: OUT } });
  if (hero) {
    var chars = hero.querySelectorAll('.big .ch');
    var video = hero.querySelector('video');
    gsap.set(hero.querySelector('.big'), { opacity: 1 });
    gsap.set(chars, { yPercent: 115, rotate: 3 });
    if (video) gsap.set(video, { scale: 1.14, opacity: 0 });
    intro
      .to(video, { opacity: 1, duration: 1.4, ease: 'power2.out' }, 0)
      .to(video, { scale: 1, duration: 3.2, ease: 'power3.out' }, 0)
      .fromTo('[data-hero-kicker]', { y: 18, opacity: 0 }, { y: 0, opacity: 1, duration: 0.9 }, 0.25)
      .to(chars, { yPercent: 0, rotate: 0, duration: 1.1, stagger: { each: 0.03, from: 'start' }, ease: 'power4.out' }, 0.35)
      .fromTo('[data-hero-sub]', { y: 14, opacity: 0 }, { y: 0, opacity: 1, duration: 0.9 }, 0.95)
      .fromTo('[data-hero-ctas]', { y: 22, opacity: 0 }, { y: 0, opacity: 1, duration: 0.9 }, 1.1)
      .fromTo('[data-hero-right]', { y: 24, opacity: 0 }, { y: 0, opacity: 1, duration: 1 }, 1.25)
      .fromTo('[data-hero-scroll], [data-hero-follow]', { opacity: 0 }, { opacity: 1, duration: 1 }, 1.5);

    // Hero: parallax al hacer scroll (el video se queda atrás, el texto sube y se desvanece)
    gsap.to('[data-hero-media]', {
      yPercent: 16, ease: 'none',
      scrollTrigger: { trigger: hero, start: 'top top', end: 'bottom top', scrub: true }
    });
    gsap.to('[data-hero-content]', {
      y: -110, opacity: 0, ease: 'none',
      scrollTrigger: { trigger: hero, start: '25% top', end: 'bottom top', scrub: true }
    });
    gsap.fromTo('[data-hero-scroll], [data-hero-follow]', { opacity: 1 }, {
      opacity: 0, ease: 'none', immediateRender: false,
      scrollTrigger: { trigger: hero, start: '5% top', end: '40% top', scrub: true }
    });
  }

  // ── Preloader ──
  function arrancar() {
    html.classList.remove('is-loading');
    intro.play();
    ScrollTrigger.refresh();
  }
  if (html.classList.contains('is-loading')) {
    var ld = document.querySelector('.loader');
    var tl = gsap.timeline({ onComplete: arrancar });
    tl.to('.ld-p', { strokeDashoffset: 0, duration: 0.9, ease: 'power2.inOut', stagger: 0.1 }, 0)
      .to('.ld-word span', { opacity: 1, y: 0, duration: 0.5, stagger: 0.06, ease: OUT }, 0.35)
      .to('.ld-line span', { scaleX: 1, duration: 0.8, ease: 'power2.inOut' }, 0.3)
      .to('.ld-in', { opacity: 0, y: -14, duration: 0.35, ease: 'power2.in' }, 1.2)
      .to(ld, { yPercent: -100, duration: 0.75, ease: 'expo.inOut' }, 1.3)
      .set(ld, { display: 'none' });
    window.scrollTo(0, 0);
  } else {
    // Sin preloader: intro directa apenas hay pintado
    requestAnimationFrame(function () { requestAnimationFrame(arrancar); });
  }

  // ── Reveals genéricos ──
  gsap.utils.toArray('[data-rv]').forEach(function (el) {
    gsap.fromTo(el, { y: 26, opacity: 0 }, {
      y: 0, opacity: 1, duration: 1, ease: OUT,
      scrollTrigger: { trigger: el, start: 'top 90%', once: true }
    });
  });
  gsap.utils.toArray('[data-rv-lines]').forEach(function (box) {
    var ps = box.querySelectorAll('p');
    if (!ps.length) return;
    gsap.fromTo(ps, { y: 22, opacity: 0 }, {
      y: 0, opacity: 1, duration: 1, stagger: 0.14, ease: OUT,
      scrollTrigger: { trigger: box, start: 'top 88%', once: true }
    });
  });
  gsap.utils.toArray('[data-line]').forEach(function (el) {
    gsap.to(el, { scaleX: 1, duration: 1.1, ease: 'power3.inOut', scrollTrigger: { trigger: el, start: 'top 90%', once: true } });
  });

  // Títulos fantasma: aparecen y luego se deslizan con el scroll (parallax horizontal)
  gsap.utils.toArray('.ghost-head').forEach(function (gh) {
    var g = gh.querySelector('.ghost');
    if (!g) return;
    gsap.fromTo(g, { opacity: 0, xPercent: -6 }, { opacity: 1, xPercent: 0, duration: 1.3, ease: OUT, scrollTrigger: { trigger: gh, start: 'top 92%', once: true } });
    if (!movil) gsap.fromTo(g, { x: -30 }, { x: 70, ease: 'none', scrollTrigger: { trigger: gh, start: 'top bottom', end: 'bottom top', scrub: 1.2 } });
  });

  // Tarjetas: entran en cascada (también las que están fuera de vista a la derecha en la fila)
  var cards = gsap.utils.toArray('.pcard, [data-pcard]');
  if (cards.length) {
    gsap.set(cards, { y: 44, opacity: 0 });
    ScrollTrigger.batch(cards, {
      start: 'top 92%', once: true,
      onEnter: function (lote) { gsap.to(lote, { y: 0, opacity: 1, duration: 0.9, stagger: 0.06, ease: OUT, overwrite: true, clearProps: 'transform', onComplete: function () { lote.forEach(function (c) { c.classList.add('rev'); }); } }); }
    });
  }

  // Parallax de imágenes/marcas (data-parallax = desplazamiento en %)
  gsap.utils.toArray('[data-parallax]').forEach(function (el) {
    var f = parseFloat(el.getAttribute('data-parallax')) || 12;
    var target = el.querySelector('img') || el;
    gsap.fromTo(target, { yPercent: -f / 2 }, { yPercent: f / 2, ease: 'none', scrollTrigger: { trigger: el, start: 'top bottom', end: 'bottom top', scrub: true } });
  });

  // Opiniones: la cita aparece palabra por palabra
  gsap.utils.toArray('.fb-quote p[data-split]').forEach(function (p) {
    gsap.set(p, { opacity: 1 });
    gsap.fromTo(p.querySelectorAll('.ch'), { opacity: 0, y: 10 }, {
      opacity: 1, y: 0, duration: 0.7, stagger: 0.035, ease: OUT,
      scrollTrigger: { trigger: p, start: 'top 85%', once: true }
    });
  });

  // Ficha de producto: título letra por letra + bloques
  var pinfo = document.querySelector('[data-pinfo]');
  if (pinfo) {
    var h1 = pinfo.querySelector('h1[data-split]');
    if (h1) {
      gsap.set(h1, { opacity: 1 });
      gsap.fromTo(h1.querySelectorAll('.ch'), { yPercent: 110 }, { yPercent: 0, duration: 0.9, stagger: 0.022, ease: 'power4.out', delay: 0.15 });
    }
    gsap.fromTo('[data-gallery]', { opacity: 0, scale: 0.98 }, { opacity: 1, scale: 1, duration: 1.1, ease: OUT });
    gsap.fromTo(pinfo.querySelectorAll('.save, .lowstock, .promo-cd, .bundle-aviso, .desc, .p-form, .p-perks'), { y: 20, opacity: 0 }, { y: 0, opacity: 1, duration: 0.9, stagger: 0.08, ease: OUT, delay: 0.35 });
  }

  // Marca gigante del pie: sube desde abajo mientras entra el footer
  var big = document.querySelector('[data-foot-big] span');
  if (big) { gsap.set(big, { yPercent: 60, opacity: 0 }); gsap.to(big, { yPercent: 12, opacity: 1, ease: 'none', scrollTrigger: { trigger: '[data-foot-big]', start: 'top bottom', end: 'bottom bottom', scrub: 0.6 } }); }

  // Cinta dorada: avanza sola y acelera con la velocidad del scroll
  var track = document.querySelector('[data-mq-track]');
  if (track) {
    track.style.animation = 'none';
    var mq = gsap.to(track, { xPercent: -50, ease: 'none', duration: movil ? 26 : 34, repeat: -1 });
    var vuelta = null;
    ScrollTrigger.create({
      onUpdate: function (self) {
        var v = Math.min(Math.abs(self.getVelocity()) / 900, 5);
        mq.timeScale(1 + v);
        if (vuelta) vuelta.kill();
        vuelta = gsap.to(mq, { timeScale: 1, duration: 1.2, ease: 'power2.out', delay: 0.1 });
      }
    });
  }

  // Newsletter: foco de luz siguiendo al mouse
  if (esMouse) {
    document.querySelectorAll('[data-spot]').forEach(function (box) {
      box.addEventListener('mousemove', function (e) {
        var r = box.getBoundingClientRect();
        box.style.setProperty('--mx', (e.clientX - r.left) + 'px');
        box.style.setProperty('--my', (e.clientY - r.top) + 'px');
      });
    });
  }


  // ══════════════════════════ v4 "Sin explicación" ══════════════════════════
  // Tilt 3D: el elemento gira siguiendo al mouse dentro de su "zona" (tarjeta / sección)
  if (esMouse) {
    document.querySelectorAll('[data-tilt]').forEach(function (el) {
      var max = parseFloat(el.getAttribute('data-tilt')) || 8;
      gsap.set(el, { transformPerspective: 1100 });
      var rx = gsap.quickTo(el, 'rotationX', { duration: 0.7, ease: OUT });
      var ry = gsap.quickTo(el, 'rotationY', { duration: 0.7, ease: OUT });
      var zona = el.closest('.h4, .sc-card, .pc4, .mt-item, .bd-in, .p-gallery') || el;
      zona.addEventListener('mousemove', function (e) {
        var r = zona.getBoundingClientRect();
        var px = (e.clientX - r.left) / r.width - 0.5, py = (e.clientY - r.top) / r.height - 0.5;
        rx(-py * max * 2); ry(px * max * 2);
      });
      zona.addEventListener('mouseleave', function () { rx(0); ry(0); });
    });
  }

  // Hero v4: titular gigante letra por letra + la pieza cae, se enfoca y queda flotando
  var h4 = document.querySelector('[data-h4]');
  if (h4) {
    var l1 = h4.querySelectorAll('.h4-big-l1 .ch'), l2 = h4.querySelectorAll('.h4-big-l2 .ch');
    gsap.set(h4.querySelectorAll('.h4-big [data-split]'), { opacity: 1 });
    gsap.set([l1, l2], { yPercent: 120 });
    gsap.set('[data-h4-piece]', { opacity: 0, y: 90, scale: 1.2, filter: 'blur(16px)' });
    intro
      .to(l1, { yPercent: 0, duration: 1.1, stagger: 0.06, ease: 'power4.out' }, 0.1)
      .to(l2, { yPercent: 0, duration: 1.1, stagger: 0.035, ease: 'power4.out' }, 0.25)
      .to('[data-h4-piece]', { opacity: 1, y: 0, scale: 1, filter: 'blur(0px)', duration: 1.7, ease: 'power3.out' }, 0.55)
      .fromTo('[data-h4-tag]', { opacity: 0, y: 14 }, { opacity: 1, y: 0, duration: 0.8 }, 1.6)
      .fromTo('[data-h4-left]', { opacity: 0, y: 26 }, { opacity: 1, y: 0, duration: 0.9 }, 1.25)
      .fromTo('[data-h4-right]', { opacity: 0, y: 26 }, { opacity: 1, y: 0, duration: 0.9 }, 1.4)
      .fromTo('[data-hero-scroll]', { opacity: 0 }, { opacity: 1, duration: 0.8 }, 1.8);
    // Flotación continua (respira)
    gsap.to('[data-h4-float]', { y: -18, rotation: 1.4, duration: 3.4, ease: 'sine.inOut', yoyo: true, repeat: -1 });
    // Parallax al bajar: la pieza sube y se encoge, el titular se queda atrás, el pie se desvanece
    gsap.to('[data-h4-piece]', { yPercent: -34, scale: 0.84, ease: 'none', scrollTrigger: { trigger: h4, start: 'top top', end: 'bottom top', scrub: true } });
    gsap.to('[data-h4-big]', { yPercent: 22, opacity: 0.25, ease: 'none', scrollTrigger: { trigger: h4, start: 'top top', end: 'bottom top', scrub: true } });
    gsap.to(h4.querySelector('.h4-in'), { y: -50, opacity: 0, ease: 'none', scrollTrigger: { trigger: h4, start: '25% top', end: '85% top', scrub: true } });
  }

  // Hero v5: la entrada es CSS (no depende de esto). Aquí solo el parallax al bajar, en escritorio:
  // la foto se queda atrás y el texto sube y se desvanece.
  var h5 = document.querySelector('[data-h5]');
  if (h5 && !movil) {
    gsap.to(h5.querySelector('[data-h5-media] picture'), { yPercent: 12, ease: 'none', scrollTrigger: { trigger: h5, start: 'top top', end: 'bottom top', scrub: true } });
    gsap.to(h5.querySelector('.h5-in'), { y: -70, opacity: 0, ease: 'none', scrollTrigger: { trigger: h5, start: '30% top', end: '90% top', scrub: true } });
  }

  // Titulares partidos en letras (colección, lookbook, materiales, 2×½): suben desde la máscara al entrar
  gsap.utils.toArray('[data-split="chars"]').forEach(function (el) {
    if (el.closest('[data-hero], [data-h4], [data-pinfo]')) return;
    gsap.set(el, { opacity: 1 });
    gsap.fromTo(el.querySelectorAll('.ch'), { yPercent: 110 }, { yPercent: 0, duration: 0.95, stagger: 0.025, ease: 'power4.out', scrollTrigger: { trigger: el, start: 'top 88%', once: true } });
  });

  // Manifiesto: sección fijada; las palabras se encienden con el scroll y la foto respira
  var mf = document.querySelector('[data-mf]');
  if (mf) {
    var mfText = mf.querySelector('[data-mf-text]');
    partir(mfText, 'words');
    var mfW = mfText.querySelectorAll('.w');
    // La sección se fija con position:sticky (CSS); aquí solo se anima el texto según el avance del wrapper
    var mfWrap = document.querySelector('[data-mf-wrap]') || mf;
    gsap.to(mfW, { opacity: 1, stagger: 0.06, ease: 'none', scrollTrigger: { trigger: mfWrap, start: 'top top', end: 'bottom bottom', scrub: 0.5 } });
    gsap.fromTo(mf.querySelector('.mf-bg img'), { yPercent: -6, scale: 1.06 }, { yPercent: 4, scale: 1, ease: 'none', scrollTrigger: { trigger: mf, start: 'top bottom', end: 'bottom top', scrub: true } });
  }

  // Colección horizontal: en escritorio la sección se fija y la pista avanza con el scroll
  var sc = document.querySelector('[data-sc]');
  if (sc) {
    var track = sc.querySelector('[data-sc-track]'), pinEl = sc.querySelector('[data-sc-pin]'), prog = sc.querySelector('[data-sc-prog]');
    var scCards = sc.querySelectorAll('[data-sc-card]');
    if (!movil) {
      // Fijado con position:sticky (CSS). El wrapper mide 100svh + distancia horizontal, y la pista
      // se desplaza según el avance del wrapper. Sin pin de GSAP: sin brincos con Lenis.
      var wrap = sc.querySelector('[data-sc-wrap]');
      var dist = function () { return Math.max(0, track.scrollWidth - window.innerWidth + 42); };
      var medir = function () { wrap.style.height = (window.innerHeight + dist()) + 'px'; };
      medir();
      gsap.to(track, {
        x: function () { return -dist(); }, ease: 'none',
        scrollTrigger: {
          trigger: wrap, start: 'top top', end: 'bottom bottom', scrub: 0.7, invalidateOnRefresh: true,
          onRefreshInit: medir,
          onUpdate: function (self) { if (prog) prog.style.transform = 'scaleX(' + self.progress + ')'; }
        }
      });
    }
    gsap.fromTo(scCards, { y: 70, opacity: 0 }, { y: 0, opacity: 1, duration: 1.1, stagger: 0.09, ease: OUT, scrollTrigger: { trigger: pinEl, start: 'top 85%', once: true } });
  }

  // Lookbook: las fotos se "abren" (clip) al entrar
  var lbItems = gsap.utils.toArray('[data-lb-item]');
  if (lbItems.length) {
    gsap.set(lbItems, { opacity: 1, clipPath: 'inset(18% 0 18% 0 round 20px)', y: 40 });
    ScrollTrigger.batch(lbItems, { start: 'top 88%', once: true, onEnter: function (b) { gsap.to(b, { clipPath: 'inset(0% 0 0% 0 round 20px)', y: 0, duration: 1.3, stagger: 0.14, ease: 'power3.out' }); } });
  }

  // Oferta 2×½: las dos piezas entran de lados opuestos y quedan flotando a destiempo
  var bd = document.querySelector('[data-bd]');
  if (bd) {
    var ba = bd.querySelector('[data-bd-a]'), bb = bd.querySelector('[data-bd-b]');
    if (ba) gsap.fromTo(ba, { x: -90, opacity: 0, rotation: -10 }, { x: 0, opacity: 1, rotation: -4, duration: 1.3, ease: OUT, scrollTrigger: { trigger: bd, start: 'top 75%', once: true },
      onComplete: function () { gsap.to(ba, { y: -12, rotation: -2, duration: 3, ease: 'sine.inOut', yoyo: true, repeat: -1 }); } });
    if (bb) gsap.fromTo(bb, { x: 90, opacity: 0, rotation: 10 }, { x: 0, opacity: 1, rotation: 5, duration: 1.3, delay: 0.15, ease: OUT, scrollTrigger: { trigger: bd, start: 'top 75%', once: true },
      onComplete: function () { gsap.to(bb, { y: 12, rotation: 3, duration: 3.6, ease: 'sine.inOut', yoyo: true, repeat: -1 }); } });
  }

  // Ficha v4: la pieza recortada flota
  var pgCut = document.querySelector('.main-cut .pg-cut');
  if (pgCut) gsap.to(pgCut, { y: -12, duration: 3.2, ease: 'sine.inOut', yoyo: true, repeat: -1 });

  // ── Transición entre páginas: cortina negra con línea dorada ──
  var veil = document.querySelector('.pt-veil');
  if (veil) {
    document.addEventListener('click', function (e) {
      var a = e.target.closest('a[href]');
      if (!a || e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
      if (a.target === '_blank' || a.hasAttribute('download') || a.hasAttribute('data-cart-open') || a.hasAttribute('data-no-pt')) return;
      var href = a.getAttribute('href');
      if (!href || href.charAt(0) === '#' || /^(mailto|tel|javascript):/.test(href)) return;
      var url;
      try { url = new URL(a.href, location.href); } catch (er) { return; }
      if (url.origin !== location.origin) return;
      if (url.pathname === location.pathname && url.search === location.search && url.hash) return;
      if (/\/(checkout|account|cart\/change|cart\/add|discount)/.test(url.pathname)) return;
      e.preventDefault();
      gsap.to(veil, { scaleY: 1, transformOrigin: 'bottom', duration: 0.5, ease: 'power3.inOut', onComplete: function () { location.href = url.href; } });
    });
    // Al volver con el botón "atrás" (bfcache) la cortina debe estar abierta
    window.addEventListener('pageshow', function (ev) { if (ev.persisted) gsap.set(veil, { scaleY: 0 }); });
  }

  // Cuando cambian imágenes/fuentes, recalcular posiciones de scroll (con pausa para no hacerlo 50 veces)
  var refrescar = (function () { var t; return function () { clearTimeout(t); t = setTimeout(function () { ScrollTrigger.refresh(); }, 180); }; })();
  window.addEventListener('load', refrescar);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(refrescar);
  document.querySelectorAll('img').forEach(function (im) { if (!im.complete) im.addEventListener('load', refrescar, { once: true }); });
})();
